export const defaultStyle = {
  containerDiv: "md:max-w-md lg:max-w-lg xl:max-w-xl px-[15px] mx-auto relative",
  timeTabWrapper:"hidden md:block px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  timeTab:
    "flex pb-[10px] pt-[3px] border-2 border-solid border-blueViolet bg-blueViolet text-center justify-evenly px-[20px] mb-[20px] box-border",
  yearButton:
    "font-MDLZBiteType  md:text-[30px] lg:text-[60px] tracking-[1.2px] md:leading-[40px] lg:leading-[60px] bg-transparent text-white text-center w-full hover:no-underline hover:border-b-2 hover:border-solid hover:border-orange hover:block px-[5px]",
  yearsDiv: "px-[35px] md:px-[15px] mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl",
  dateTime: "w-full !mb-[35px] md:px-[20px] lg:px-[0px]",
  timeStyle: "md:text-[21px] text-[14px] text-black text-left ",
  yearFlex: "inline-block box-border text-[16px] leading-[24px] tracking-normal",
  yearRelease:
    "font-MDLZBiteType text-[60px] tracking-[1.2px] text-black leading-[72px] mb-[35px] pb-[35px] md:pb-[35px] lg:pb-[0px]",
  linksWrapper:
    "font-Regular text-[14px] md:text-[21px] font-bold text-purple tracking-[0.53px] md:tracking-[2.2px] leading-[21px] md:leading-[31.5px] text-left",
    topLink: "md:block fixed hidden bottom-[10%] md:right-0 py-[15px] md:z-[99] bg-blueViolet text-center mt-[20px] cursor-pointer",
    topText:"text-[16px] uppercase tracking-[4.2px] text-white px-[20px]",
    links:"Links  hover:border-b-2 hover:border-solid hover:no-underline hover:text-orange ",
    yearReleaseDiv:"yearReleaseDiv  md:mb-[35px] lg:mb-[0px]",
    yearReleaseContainer:"yearReleaseContainer first:mt-[0px] md:first:mt-[50px] mt-[50px] pb-[20px] md:pb-[0.2px] last:pb-[0px]",
  }
  


export const YEAR_LANGUAGE = {
  ...defaultStyle,
  containerDiv: "md:max-w-md lg:max-w-lg xl:max-w-xl px-[15px] mx-auto relative",
  timeTabWrapper:"timeTabWrapper hidden md:block box-border px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  timeTabWrap:"timeTabWrap",
  yearButton:"text-[30px] lg:text-[25px] tracking-[1.2px] font-MDLZBiteType leading-[1.2] text-white hover:underline hover:decoration-oranage400 px-[5px]",
  yearFlex: "inline-block box-border text-[16px] leading-[24px] tracking-normal",
  timeTab:
  "flex pb-[10px] pt-[3px] border-2 border-solid border-blueViolet bg-blueViolet text-center justify-evenly px-[5px] mb-[20px] box-border",
  linksWrapper:
  "font-Regular text-[14px] md:text-[21px] font-bold text-purple tracking-[0.53px] md:tracking-[2.2px] leading-[21px] md:leading-[31.5px] text-left",
  yearRelease:
  "font-MDLZBiteType text-[60px] tracking-[1.2px] text-black leading-[72px] mb-[35px] pb-[35px] md:pb-[35px] lg:pb-[0px]",
  yearButtonInactive:"text-[30px] tracking-[1.2px] font-MDLZBiteType lg:leading-[60px] md:leading-[40px] text-inactivePurple hover:underline hover:decoration-oranage400 px-[5px]",
  links:"Links  hover:border-b-2 hover:border-solid hover:no-underline hover:text-orange ",
  yearReleaseDiv:"yearReleaseDiv md:mb-[35px] lg:mb-[0px]",
  yearsDiv: "px-[35px] md:px-[15px] mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl",
  yearReleaseContainer:"yearReleaseContainer first:mt-[0px] md:first:mt-[50px] mt-[50px] pb-[20px] md:pb-[0.2px] last:pb-[0px]",
}

export const NoTab = {
  ...YEAR_LANGUAGE,
  timeTab:
  "timeTab",
  yearRelease:
  "font-MDLZBiteType text-[60px] tracking-[1.2px] text-black leading-[72px] mb-[35px] pb-[35px] md:pb-[35px] lg:pb-[0px]",
  timeTabWrapper:"timeTabWrapper hidden md:block md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  linksWrapper:
  "font-Regular text-[14px] md:text-[21px] font-bold text-purple tracking-[0.53px] md:tracking-[2.2px] leading-[21px] md:leading-[31.5px] text-left",
  yearReleaseContainer:"yearReleaseContainer first:mt-[0px] md:first:mt-[0px] mt-[50px] pb-[20px] md:pb-[0.2px] last:pb-[0px]",
  
}

